import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Segment, Dropdown, Header } from 'semantic-ui-react';
import { getIdentityMappings, deleteIdentityMapping } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { yesNo } from '../../utils/defaults';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
import { NotificationManager } from 'react-notifications';

const initialState = {
    templateName: "",
    groupName: "",
    active: ""
}

class IdentityMapping extends Component {

    constructor(props) {
        super(props);
        this.state = {
          loading: true,
          deleteIdentityModal: false,
          identityMappings: [],
          mappingId: 0,
          searchIndex: initialState
        }
      }

    componentDidMount() {
        this.props.addItem("helpFile", "identity-mapping.md");
        this.loadIdentityMapping();
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    loadIdentityMapping = () => {
        this.setState((prevState, props) => {
            return { loading: true }
        }, () => {
            getIdentityMappings(this.state.searchIndex).then(response => {
                if (response !== null) {
                    this.setState((prevState, props) => {
                        return { identityMappings: response, loading: false }
                    })
                }
            }).then((error) => {
                this.setState({ loading: false })
            });
        });
    }
    deleteIdentityMapping = () => {
        deleteIdentityMapping(this.state.mappingId).then(response => {
          if(response != null){
            NotificationManager.success('Success', 'Deleted successfully.');
            this.setState((prevState, props) => {
              return {
                  identityMappings: this.state.identityMappings.filter((u) => {
                  return u.iimID !== this.state.mappingId;
                }), deleteIdentityModal: false, mappingId: 0
              }})
           }
        })
      }

      openDeleteModal = (id) => {
        this.setState((prevState, props) => {
          return { deleteIdentityModal: true, mappingId: id }
        });
      }

      close = () => {
        this.setState((prevState, props) => {
          return { deleteIdentityModal: false }
        })
      }

      resetSearch = () => {
        this.setState((prevState, props) => {
          return {
            searchIndex: initialState
          }
        }, () => this.loadIdentityMapping())
      }

      handleChange = (e, data) => {
        this.setState({
          searchIndex: {
            ...this.state.searchIndex,
            [data.name]: data.value
          }
        });
      }

      render() {
        if (this.state.loading) {
          return (
            <Loading />
          )
        }
        const { identityMappings } = this.state;
        return (
          <div>
            <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "IdentityMapping", url: null }]} />
            <Grid className="g-bkgd">
              <Grid.Row>
                <Grid.Column>
                  <Form className="small">
                    <Form.Group widths='equal'>
                      <Form.Field width={4}>
                        <label>Group Name:</label>
                        <Form.Input placeholder='Group Name' onChange={this.handleChange} value={this.state.searchIndex.groupName} name="groupName" />
                      </Form.Field>
                      <Form.Field width={4}>
                        <label>Template Name:</label>
                        <Form.Input placeholder='Template Name' onChange={this.handleChange} value={this.state.searchIndex.templateName} name="templateName" />
                      </Form.Field>
                      <Form.Field width={3}>
                        <label>Active Status:</label>
                        <Dropdown placeholder='Active Status' className="fluid" selection options={yesNo} value={this.state.searchIndex.active} onChange={this.handleChange} name="active"></Dropdown>
                      </Form.Field>
                      <Form.Field width={2}>
                        <Button.Group className="small push-down">
                          <Button onClick={this.resetSearch}>{this.props.t("reset")}</Button>
                          <Button.Or />
                          <Button positive onClick={this.loadIdentityMapping}>{this.props.t("submit")}</Button>
                        </Button.Group>
                      </Form.Field>
                    </Form.Group>
                  </Form>
                  <Segment.Group raised>
                    <Segment.Group horizontal>
                      <Segment color="grey" inverted>
                        <Header as="h4">
                          <Icon name="users" />
                          <div className="content">
                            Identity Groups
                           </div>
                        </Header>
                      </Segment>
                      <Segment color="grey" inverted>
                        <Button as={Link} to={"/clientmap/0"} className="inverted right floated small">
                          Add a group
                          </Button>
                      </Segment>
                    </Segment.Group>
                    <ReactTable minRows={0} filterable defaultPageSize={this.props.reactTable().pageSize} showPagination={identityMappings.length > this.props.reactTable().identityMappings ? true : false} defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                      data={identityMappings}
                      getNoDataProps={() => {
                        return { style: { display: 'none' } };
                      }}
                      columns={[{
                        Header: props => <span data-inverted="" data-tooltip="Group Name" data-position="bottom left">Group Name</span>,
                        accessor: 'immGroupName' 
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Template Name" data-position="bottom left">Template Name</span>,
                        accessor: 'limTemplateName',
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Client count" data-position="bottom left">#Clients</span>,
                        accessor: 'clientCount',
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Is group is deactivated?" data-position="bottom right">Active Status</span>,
                        id: 'iimActive',
                        width: 90,
                        style: {
                          textAlign: "center"
                        },
                        filterable: false,
                        accessor: row => (
                          row.iimActive === 'Y' ? "Yes" : "No"
                        )
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                        filterable: false,
                        width: 130,
                        style: {
                          textAlign: "center"
                        },
                        Cell: row => (
                          <div>
                            <Button as={Link} to={"/clientmap/" + row.original.iimID} className="icon mini" data-tooltip="Edit group" data-inverted="" data-position="top right" ><Icon name="pencil alternate" /></Button>
                            <Button onClick={() => this.openDeleteModal(row.original.iimID)} className="icon mini" data-inverted="" data-tooltip="Delete group" data-position="top right"><Icon name="trash alternate outline" /></Button>
                          </div>
                        )
                      }]}
                    />
                  </Segment.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <MessageBox {...this.props} box={12} size="tiny" open={this.state.deleteIdentityModal} close={this.close} contentTitle="Delete group?" content="Are you sure you want to delete this group?" yesHandle={this.deleteIdentityMapping} />
          </div>
        );
      }
    }

    export default IdentityMapping;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/IdentityMapping.js